import { FormInstance } from "antd/es/form";
import React from "react";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { PTSMasterScreen_ScreenContext } from "../ptsmasterscreen/ptsmasterscreen-context";

declare let window: any;

export interface IProjelercopy_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IProjelercopy_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
}

export class Projelercopy_ScreenBase extends React.PureComponent<
  IProjelercopy_ScreenProps,
  any
> {
  static contextType = PTSMasterScreen_ScreenContext;
  declare context: React.ContextType<typeof PTSMasterScreen_ScreenContext>;
  projelercopy_64322_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "08e1cb20-24ad-e190-d46b-beded98dd4ae",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "4106607f-9ae3-47ff-8d8a-3ced44ab92c6",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "1dce2c2a-d6ba-4a18-a563-de63d3c900df",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 900204, PropertyName: "tab", Value: "📊 Dashboard" },
        { Id: 474634, PropertyName: "value", Value: "47" },
        { Id: 15196, PropertyName: "value", Value: "Toplam Proje" },
        { Id: 767561, PropertyName: "value", Value: "23" },
        { Id: 462819, PropertyName: "value", Value: "Devam Eden" },
        { Id: 714167, PropertyName: "value", Value: "12" },
        { Id: 196982, PropertyName: "value", Value: "Beklemede" },
        { Id: 82563, PropertyName: "value", Value: "8" },
        { Id: 464094, PropertyName: "value", Value: "Arıza Kaydı" },
        { Id: 448613, PropertyName: "value", Value: "Son Projeler" },
        { Id: 663363, PropertyName: "label", Value: "Yeni Proje" },
        { Id: 921216, PropertyName: "title", Value: "  Proje Adı" },
        { Id: 656055, PropertyName: "value", Value: "ABC Fabrika GES" },
        { Id: 708714, PropertyName: "title", Value: "Kategori" },
        { Id: 777042, PropertyName: "value", Value: "Çatı GES" },
        { Id: 248426, PropertyName: "title", Value: "Müşteri" },
        { Id: 92721, PropertyName: "value", Value: "ABC Tekstil A.Ş." },
        { Id: 537723, PropertyName: "title", Value: "Durum" },
        { Id: 506025, PropertyName: "value", Value: "Tamamlandı" },
        { Id: 452154, PropertyName: "value", Value: "Devam Ediyor" },
        { Id: 637541, PropertyName: "value", Value: "Beklemede" },
        { Id: 383949, PropertyName: "title", Value: "İlerleme" },
        { Id: 788420, PropertyName: "value", Value: "65% Tamamlandı" },
        { Id: 798557, PropertyName: "title", Value: "Başlangıç" },
        { Id: 658989, PropertyName: "value", Value: "15.01.2026" },
        { Id: 865940, PropertyName: "title", Value: "Bitiş" },
        { Id: 646952, PropertyName: "value", Value: "30.03.2026" },
        { Id: 549263, PropertyName: "title", Value: "İşlemler" },
        { Id: 394366, PropertyName: "tab", Value: "🏠 Çatı GES" },
        { Id: 92451, PropertyName: "value", Value: "Çatı GES içerik alanı" },
        { Id: 993133, PropertyName: "tab", Value: "🌿 Arazi GES" },
        { Id: 12794, PropertyName: "value", Value: "Arazi GES içerik alanı" },
        { Id: 948236, PropertyName: "tab", Value: "💧 Tarımsal Sulama" },
        { Id: 997442, PropertyName: "tab", Value: "🔌 Araç Şarj İstasyonu" },
        { Id: 777656, PropertyName: "tab", Value: "🌡️ Isı Pompası" },
        { Id: 167900, PropertyName: "tab", Value: "🏡 Akıllı EV" },
        { Id: 182789, PropertyName: "tab", Value: "⚠️ Arıza Takip" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.projelercopy_64322_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "projelercopy",
        "ptsmasterscreen_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "projelercopy",
      "ptsmasterscreen_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "projelercopy",
      "ptsmasterscreen_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  checkTabErrors = () => {
    document.querySelectorAll(".rc-tabs-tab").forEach((tab) => {
      (tab as HTMLElement).style.color = "";
    });

    const tabPanes = document.querySelectorAll(".rc-tabs-tabpane");
    const tabs = document.querySelectorAll(".rc-tabs-tab");

    tabPanes.forEach((tabPane, index) => {
      const uniquePaneId = `rc-tabs-tabpane-${index}`;
      if (!tabPane.hasAttribute("id")) {
        tabPane.setAttribute("id", uniquePaneId);
      }

      const uniqueTabId = `rc-tabs-tab-${index}`;
      if (tabs[index]) {
        if (!tabs[index].hasAttribute("id")) {
          tabs[index].setAttribute("id", uniqueTabId);
        }
        tabs[index].setAttribute("aria-controls", uniquePaneId);
      }
    });

    const errorElements = document.querySelectorAll(
      ".rc-tabs .ant-form-item-explain-error"
    );

    const tabsWithErrors = new Set<string>();

    errorElements.forEach((errorElement) => {
      const tabPane = errorElement.closest(".rc-tabs-tabpane");
      if (tabPane && tabPane.id) {
        tabsWithErrors.add(tabPane.id);
      }
    });

    tabsWithErrors.forEach((tabPaneId) => {
      const tab = document.querySelector(
        `.rc-tabs-tab[aria-controls="${tabPaneId}"]`
      );
      if (tab) {
        (tab as HTMLElement).style.color = "red";
      }
    });
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
